import "./Users.scss";
import { useContext, useEffect, useState, useReducer, useCallback} from "react";
import ListedUser from "./ListedUser";
import { IconJsxer } from "../../helpers/IconHelper";
import axios from "../../api/axios";
import { userListAllUsersRoute, changeUserAuthorisationRoute} from "../../api/routes";
import { toast } from "react-toastify";
import EditUser from "./EditUser";
import UserCampaignList from "./UserCampaignList";
import DropDownList from "../../components/forms/DropDownList/DropDownList";
import { getAcDropListData, getAcTypeData } from "../../helpers/AccountTypes";
import ChangeUserType from "./ChangeUserType";
import { AuthContext } from "../../contexts/AuthContext";
import InviteUser from "../../components/InviteUserPopup/InviteUser";

const Users = () => {
    const [authContext] = useContext(AuthContext);
    const acSettings = getAcTypeData(authContext.userData.accountType);
    const maxDeauthLevel = acSettings?.adminSettings?.maxDeauthLevel || 0;
    const maxChangeLevel = acSettings?.adminSettings?.maxChangeLevel || 0;

    const SORT_TYPES = {
        NAME:'name',
        EMAIL:'email',
        CAMPAIGNS:'campaigns',
        ACCOUNT_TYPE:'acType',
        AUTHORISED:'authorised',
        CREATED:'dateCreated',
    }
    const [allUserData, setAllUserData] =  useState([]);
    const [displayUserData, setDisplayUserData] =  useState([]);
    const [editingUser, setEditingUser] = useState(null);
    const [showUserCampaigns, setShowUserCampaigns] = useState(null);
    const [showChangeUserType, setShowChangeUserType] = useState(null);
    const [showInviteUserPanel, setShowInviteUserPanel] = useState(null);
    const [userTypeFilter, setUserTypeFilter] = useState(null);
    const [sortListReverse, setSortListReverse] = useState(true);
    const [currentSort, setCurrentSort] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [, forcePageUpdate] = useReducer(x => x + 1, 0);
    const [currentPage, setCurrentPage] = useState(0);
    const [, setNumberOfPages] = useState(0);
    const [hasMoreUsers, setHasMoreUsers] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const fetchUserList = useCallback(() => {
        setIsLoading(true);
        axios
        .get(userListAllUsersRoute, {
            params:{
                page:currentPage, 
                searchTerm:searchTerm, 
                userType:userTypeFilter, 
                sort:currentSort,
                reverse:sortListReverse
            },
            withCredentials: true})
        .then((response) => {
            if (currentPage === 0) {
                setAllUserData(response.data.allusers);
                setDisplayUserData(response.data.allusers);
            } else {
                // Load more - append to existing data
                setAllUserData(prev => [...prev, ...response.data.allusers]);
                setDisplayUserData(prev => [...prev, ...response.data.allusers]);
            }
            setNumberOfPages(response.data.numberOfPages);
            setHasMoreUsers(currentPage + 1 < response.data.numberOfPages);
            setIsLoading(false);
        })
        .catch((error) => {
            setIsLoading(false);
            //toast.error(error.response.data.msg);
        });
    }, [currentPage, searchTerm, userTypeFilter, currentSort, sortListReverse]);
    useEffect(() => {
        setCurrentPage(0); // Reset to first page when filters change
        forcePageUpdate();
    }, [searchTerm, currentSort, sortListReverse, userTypeFilter])
    
    useEffect(() => {
        fetchUserList();
    }, [fetchUserList]);
   
    const sortList = (event, type) => {

        event.preventDefault();
        let reverse = !sortListReverse;
        console.log(reverse)
        setSortListReverse(reverse);
        setCurrentSort(type)
    }

    const searchUserList = (e, searchTerm) => {
        setSearchTerm(searchTerm);
    }

    const refreshUserList = () => {
        console.log('Refreshing user list...');
        setCurrentPage(0);
        setAllUserData([]);
        setDisplayUserData([]);
        setHasMoreUsers(true);
        forcePageUpdate();
    }

    const toggleAuthHandler = (event, id) => {
        //console.log(id, event)
        event.preventDefault()
        axios
        .post(changeUserAuthorisationRoute, {id:id, withCrednetials:true})
        .then((response) => {
            let modifiedUsersName = ''
            let deAuthorised = true;
            let tempUserArray = allUserData.map(user => {
                if(user._id === id)
                {
                    modifiedUsersName = user.name
                    deAuthorised = user.authorised
                    return {...user, authorised:!user.authorised}
                }else
                return user
            })
            setAllUserData(tempUserArray);
            
            let tempDisplayUserArray = displayUserData.map(user => {
                if(user._id === id)
                {
                    modifiedUsersName = user.name
                    deAuthorised = user.authorised
                    return {...user, authorised:!user.authorised}
                }else
                return user
            })
            setDisplayUserData(tempDisplayUserArray);


            deAuthorised ? toast.success(modifiedUsersName+" has been successfuly disabled") : toast.success(modifiedUsersName+" has been successfuly enabled") ;
        })
        .catch ((err) => {
            toast.error("Oops something went wrong, try again");
        })
    }

    const editUserHandler = (event, id, userData) => {
        setEditingUser(userData);
    }

    const cancelEditingUser = (event) => {
        setEditingUser(null);
    }

    const openUserCampaigns = (event, id, userData) => {
        setShowUserCampaigns(userData);
    }

    const closeUserCampaigns = (event) => {
        setShowUserCampaigns(null);
    }

    const addUserHandler = (e) => {
        setShowInviteUserPanel(true);
    }

    const closeInviteUserPanel = (e) => {
        setShowInviteUserPanel(false);
    }

    const changeUserTypeHandler = (e, id, userData) => {
        setShowChangeUserType(userData);
    }

    const closeChangeUserType = (event) => {
        setShowChangeUserType(null);
    }

    const updateFilterHandler = (e, dropDownId, item) => {
        console.log('Filter update:', dropDownId, item); // Debug filter
        switch (dropDownId) {
            case 'usertype':
                setUserTypeFilter(item);
                break;
            default:
                break;
        }
    }

    const handleLoadMore = () => {
        if (!isLoading && hasMoreUsers) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    }

    return (
        <div className="content-page-container">
            <div className="content-page-top">
                <div className="fl-column grow">
                    <div className="content-top-row" style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 8 }}>
                        <div className="fl-row-slim">
                            <div>
                                <h2>Users</h2>
                            </div>
                            <div className="heading-button-container">
                                <div className={`standard-button heading-slim-button button-active`} onClick={addUserHandler}>
                                    <div className="fl-row">
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.plus, IconJsxer.ICON_STYLES.roundPanelButtonSmall)}
                                        <div>Invite a new user</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="spacing-line"></div>
                        <div className="grow"></div>
                        <input
                            type="text"
                            placeholder="Search by username"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="users-search-input"
                        />

                    </div>
                    <div className="filters-container form-holder">
                        <DropDownList 
                            id="usertype"
                            selectFunc={updateFilterHandler}
                            currentIndex={userTypeFilter ? userTypeFilter.index : 0}
                            deselectedLabel="User Type"
                            icon="oneUser"
                            items={
                                getAcDropListData(
                                    [{   
                                        id: 'all',
                                        label: 'All User Types',
                                        deselect: true,
                                    }])
                            }
                            className="filter"
                        />
                        <div className="grow"></div>
                    </div>
                    {searchTerm !== '' && <div className="light-text">Searched for: {searchTerm} ({displayUserData.length} result{displayUserData.length > 1 ? 's' : ''}) <span className="small-text">[<button type="button" className="link-button" onClick={(e) => {e.preventDefault(); searchUserList(e, '');}}>Clear Search</button>]</span></div>}
                </div>
            </div>
            <div className="content-page-content-container">
                <div className="content-page-main-content">
                    <div className="users-content">
                        <div className="users-panel">
                            <div className="horizontal-scroll-container">
                                <div className="clist-headings-container grow">
                                    <div className='fl-row list-view-content'>
                                        <div className='list-view-data-block'>
                                            <div className="header label" onClick={(event) => {sortList(event, SORT_TYPES.NAME)}}>User name {currentSort === SORT_TYPES.NAME ? (IconJsxer.GetIcon(sortListReverse ? IconJsxer.ICONS.chevronUp : IconJsxer.ICONS.chevronDown, IconJsxer.ICON_STYLES.roundFormControl)) : ''}</div>
                                        </div>
                                        <div className='list-view-data-block'>
                                            <div className="header label" onClick={(event) => {sortList(event, SORT_TYPES.EMAIL)}}>Email {currentSort === SORT_TYPES.EMAIL ? (IconJsxer.GetIcon(sortListReverse ? IconJsxer.ICONS.chevronUp : IconJsxer.ICONS.chevronDown, IconJsxer.ICON_STYLES.roundFormControl)) : ''}</div>
                                        </div>
                                        <div className='list-view-data-block'>
                                            <div className="header label">Twitch handle</div>
                                        </div>
                                        <div className='list-view-data-block'>
                                            <div className="header label" onClick={(event) => {sortList(event, SORT_TYPES.ACCOUNT_TYPE)}}>User type {currentSort === SORT_TYPES.ACCOUNT_TYPE ? (IconJsxer.GetIcon(sortListReverse ? IconJsxer.ICONS.chevronUp : IconJsxer.ICONS.chevronDown, IconJsxer.ICON_STYLES.roundFormControl)) : ''}</div>
                                        </div>
                                        <div className='list-view-data-block'>
                                            <div className="header label"></div>
                                        </div>
                                    </div>
                                </div>
                                {!isLoading && displayUserData.length === 0 ? (
                                            <div className="empty-users-state">
                                                <div className="empty-users-image">
                                                    <img src={'/assets/icons/No_Campaigns.svg'} alt="No Users" />
                                                </div>
                                                <h3 className="empty-users-title">No Users</h3>
                                                <p className="empty-users-description">
                                                    Click 'Invite a new user' button to add users. <br /> 
                                                </p>
                                            </div>
                                ) : (
                                    <div className="scroll-container-vertical-only">
                                        {
                                            displayUserData.map(
                                                (val, i) => {
                                                    return (
                                                        <ListedUser user={val} maxChangeLevel={maxChangeLevel} maxDeauthLevel={maxDeauthLevel} toggleAuthorisedFunc={toggleAuthHandler} editUserFunc={editUserHandler} openUserCampaignsFunc={openUserCampaigns} changeUserTypeFunc={changeUserTypeHandler} key={`user_${i}`} />
                                                    );
                                                }
                                            )
                                        }
                                    </div>
                                )}
                            </div>
                        </div>
                        
                        {hasMoreUsers && (
                            <div className="load-more-container">
                                <button 
                                    className={`load-more-button ${isLoading ? 'loading' : ''}`}
                                    onClick={handleLoadMore}
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Loading...' : 'Load more'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {editingUser !== null &&
                <EditUser user={editingUser} maxChangeLevel={maxChangeLevel} closePanelFunc={cancelEditingUser} onUserUpdated={refreshUserList} />
            }
            {showUserCampaigns &&
                <UserCampaignList user={showUserCampaigns} closePanelFunc={closeUserCampaigns} />
            }
            {showChangeUserType &&
                <ChangeUserType user={showChangeUserType} loggedInUser={authContext.userData} maxChangeLevel={maxChangeLevel} closePanelFunc={closeChangeUserType} refreshUserListFunc={refreshUserList} />
            }
            {showInviteUserPanel &&
                <InviteUser closePanelFunc={closeInviteUserPanel} />
            }
        </div>
    );
}

export default Users;
